import gql from 'graphql-tag';
import {flowRight as compose} from 'lodash';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {withApollo} from 'react-apollo';
import {Col, Container, Row} from 'react-bootstrap';
import {withTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {PulseLoader} from 'react-spinners';
import {validatePassword} from '../../utils';
import MandatoryInput from '../../common/components/layout/MandatoryInput';
import LoginButton from '../../common/components/LoginButton';
import {FooterRow, GradientCol, TitleButton} from '../../common/components/StyledComp';
import {Card, CardGroup, CardText, CardTitle} from '../../common/look/ui-bootstrap/components';
import LogoHeader from './LogoHeader';

const GRAPHQL_MUTATION_ACTIVATE_ACCOUNT = gql`
    mutation activateAccount($token: String!, $password: String!) {
        activateAccount(token: $token, password: $password ){
            id
        }
    }
`;

class ConfirmUser extends Component {
  state = {
    confirmed: false,
    error: null,
    loading: false,
    confirming: true,
    password: '',
    passwordConfirmation: '',
    validPassword: '',
    submitted: false,
  };

  setConfirmed = value => {
    this.setState({confirmed: value});
  };

  setError = error => {
    this.setState({error});
  };

  setLoading = loading => {
    this.setState({loading});
  };

  submitChanges() {
    const {t, match, client} = this.props;
    const token = match.params.token;
    this.setState({submitted: true});

    if (!this.state.validPassword) {
      this.setState({error:t('reg.invalidPassword')});
    } else  if (!(this.state.password === this.state.passwordConfirmation)) {
      this.setState({error:t('reg.passwordsMatch')});
    } else {
      this.setLoading(true);
      client
        .mutate({mutation: GRAPHQL_MUTATION_ACTIVATE_ACCOUNT, variables: {token: token, password: this.state.password}})
        .then(() => {
          this.setState({confirming: false});
          this.setConfirmed(true);
          this.setLoading(false);
        })
        .catch(error => {
          this.setError(error);
          this.setLoading(false);
        });
    }
  }

  render() {
    const {t} = this.props;
    const {confirmed, loading,confirming, submitted} = this.state;
    return (
      <div className="public-layout">
        <div className="login-layout">
          <Container className="container-full login-container">
            <LogoHeader/>
            {loading && (
              <Card className="confirm-email">
                <CardGroup style={{textAlign: 'center'}}>
                  <PulseLoader loading={loading}/>
                </CardGroup>
              </Card>
            )}
            {confirming && (
              <Row>
                <Col xs={{span: 10, offset: 1}} lg={{span: 6, offset: 3}} xl={{span: 4, offset: 4}} className="inputs-block">
                  <div className="login-title">{t('reg.titleCreatePassword')}</div>
                  <Container>
                    <Row>
                      <Col sm={{span: 10, offset: 1}} xs={{span: 12}}>
                        <Container>
                          <Row className="spaced-input">
                            <MandatoryInput
                              name="password"
                              type="password"
                              title={t('reg.form.field.pass')}
                              value={this.state.password}
                              onChange={(name, text) => {
                                this.setState({password : text});
                                this.setState( {validPassword : (validatePassword(text))});
                              }}
                              show={(submitted && !this.state.validPassword)}
                              customText={!this.state.validPassword ? t('reg.invalidPassword') : null}
                            />
                          </Row>
                          <Row className="spaced-input">
                            <MandatoryInput
                              name="passwordConfirmation"
                              type="password"
                              title={t('reg.form.field.passConf')}
                              value={this.state.passwordConfirmation}
                              onChange={(name, text) => {
                                this.setState({passwordConfirmation : text});
                              }}
                              show={(submitted && this.state.passwordConfirmation === '') || !(this.state.password === this.state.passwordConfirmation)}
                              customText={!(this.state.password === this.state.passwordConfirmation) && submitted ? t('reg.passwordsMatch') : null}
                            />
                          </Row>
                          <FooterRow>
                            <GradientCol sm={{span: 10, offset: 1}} xs={{span: 12}}>
                              <div className="popin-buttons">
                                <div>
                                  <TitleButton disabled={loading} onClick={() => this.submitChanges()}>
                                    {t('activateAccount')}
                                  </TitleButton>
                                </div>
                              </div>
                            </GradientCol>
                          </FooterRow>
                        </Container>
                      </Col>
                    </Row>
                  </Container>
                </Col>
                <Col xs={12} className="white-centered copyright">
                  {t('login.copyright')}
                </Col>
              </Row>
            )}
            {confirmed && (
              <Card className="confirm-email">
                <CardGroup style={{textAlign: 'center'}}>
                  <CardTitle>{t('reg.successRegTitle')}</CardTitle>
                  <CardText>{t('reg.successRegBody')}</CardText>
                  <CardText>
                    <LoginButton>
                      <Link to="/" className="button-link">
                        {t('reg.back')}
                      </Link>
                    </LoginButton>
                  </CardText>
                </CardGroup>
              </Card>
            )}
          </Container>
        </div>
      </div>
    );
  }
}

ConfirmUser.propTypes = {
  match: PropTypes.object.isRequired,
  client: PropTypes.object.isRequired,
};

export default compose(
  withApollo,
  withTranslation('login'),
)(ConfirmUser);
